import { Table, TableBody, TableRow, TableCell, Typography } from '@mui/material';
import { formatPercentage } from '../../utils/formatters';

const DifferimentTotalsTable = ({ total, paid, pending }) => {
  return (
    <>
      <Typography variant="subtitle1" sx={{ mt: 2 }}>
        Diferimiento total adeudado = Diferimiento histórico - Diferimiento pagado
      </Typography>
      <Table size="small" sx={{ mt: 1 }}>
        <TableBody>
          <TableRow>
            <TableCell>Diferimiento histórico</TableCell>
            <TableCell align="right">{formatPercentage(total)} cuotas</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Diferimiento pagado</TableCell>
            <TableCell align="right">{formatPercentage(paid)} cuotas</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Diferimiento pendiente</TableCell>
            <TableCell align="right">{formatPercentage(pending)} cuotas</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </>
  );
};

export default DifferimentTotalsTable;
